import { HUB_INTEGRATIONS, TASK_ACTIONS, TASK_TYPES } from '../../../../../util/hub-task-management/hub.constants'
import { actions as GWS_ACTIONS } from './actions'

const DEFAULT_GWS_HUB_POLL = {
  retries: 10,
  timeout: 3000,
}

// Keep in step with LICENSE_ASSIGN_RETRY_DELAYS_MS in gws_license_assign.js (1s + 2s + 4s + 8s).
const GWS_LICENSE_ASSIGN_RETRY_BUDGET_MS = 15000
// Add User assigns every selected SKU before it can return appliedLicenses.
const GWS_ADD_USER_LICENCE_RETRY_ALLOWANCE = 4

const pollWindowMs = ({ retries, timeout }) => (retries - 1) * timeout

// The shared poll waits about 27s. Two SKUs that exhaust the retry schedule already
// sleep for 30s, and user creation plus the password email run before that.
const GWS_ADD_USER_HUB_POLL = {
  retries:
    Math.ceil(
      (pollWindowMs(DEFAULT_GWS_HUB_POLL) + GWS_LICENSE_ASSIGN_RETRY_BUDGET_MS * GWS_ADD_USER_LICENCE_RETRY_ALLOWANCE) /
        DEFAULT_GWS_HUB_POLL.timeout,
    ) + 1,
  timeout: DEFAULT_GWS_HUB_POLL.timeout,
}

const GWS_HUB_TASKS = {
  [GWS_ACTIONS.GWS_ADD_USER]: {
    tasktype: TASK_TYPES.gwsOnboarding,
    action: TASK_ACTIONS.create,
    poll: GWS_ADD_USER_HUB_POLL,
  },
  [GWS_ACTIONS.GWS_PWD_RESET]: {
    tasktype: TASK_TYPES.gwsResetPassword,
    action: TASK_ACTIONS.update,
    poll: DEFAULT_GWS_HUB_POLL,
  },
  [GWS_ACTIONS.GWS_REVOKE_SESSIONS]: {
    tasktype: TASK_TYPES.gwsRevokeSessions,
    action: TASK_ACTIONS.update,
    poll: DEFAULT_GWS_HUB_POLL,
  },
  [GWS_ACTIONS.GWS_DISABLE_USER]: {
    tasktype: TASK_TYPES.gwsUser,
    action: TASK_ACTIONS.update,
    poll: DEFAULT_GWS_HUB_POLL,
  },
  [GWS_ACTIONS.GWS_ENABLE_USER]: {
    tasktype: TASK_TYPES.gwsUser,
    action: TASK_ACTIONS.update,
    poll: DEFAULT_GWS_HUB_POLL,
  },
}

export const getGwsHubTask = (action) => GWS_HUB_TASKS[action] ?? null

export const GWS_HUB_INTEGRATION = HUB_INTEGRATIONS.google

export { DEFAULT_GWS_HUB_POLL, GWS_HUB_TASKS }
